module.exports = __webpack_public_path__ + "static/img/video.3dff784.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/video.svg
// module id = Y9lF
// module chunks = 0